var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-upload-image"},[_c('el-upload',{ref:"imageUpload",staticClass:"upload-demo",attrs:{"action":"#","auto-upload":false,"on-change":_vm.handleBeforeUpload,"show-file-list":false}},[_c('el-button',{staticClass:"btn",attrs:{"size":"small","type":"primary"}},[_vm._v("更换头像")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }